import { Component, OnInit } from '@angular/core';
import { UntypedFormGroup, UntypedFormBuilder, Validators } from '@angular/forms';

@Component({
  selector: 'app-modal-consulta',
  templateUrl: './modal-consulta.component.html',
  styleUrls: ['./modal-consulta.component.scss']
})
export class ModalConsultaComponent implements OnInit {
  loginForm:UntypedFormGroup;

  constructor(private form:UntypedFormBuilder,) { 
    this.loginForm = this.form.group({
      consulta:['', [Validators.required]],
      email:['', [Validators.required]],
    });
  }

  ngOnInit(): void {
  }

}
